import React from 'react';
import { Link, IndexLink } from 'react-router-dom';

import * as constant from "../../../constants/constant";
import * as ImageUrl from "../../../constants/constant";

export default function DisputeFooter(props) {
    let inputElement = React.createRef();
	var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    if (user && user.gender == undefined) {
        user = { ...user, gender: 'Male' }
        // localStorage.setItem('user', JSON.stringify(user));
        // user = JSON.parse(localStorage.getItem("user"));
    }
    // var gender = localStorage.getItem('user')
    var defaultImagePath = (user && user.gender) == 'Male' ?
        constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
    var imagePath = ''
    if (user && user.image == "noUserImage.jpg") {
        imagePath = user && user.gender == 'Male' ?
            constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
    } else {
        imagePath =
            ImageUrl.PRODUCTION_IMAGE_URL +
            "uploads/" +
            localStorage.getItem("userId") +
            "/" +
            (user && user.image);
    }
    return (
        <footer className="text-center colorFooter">
                            <div className="container">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <ul className="foterList">
                                            <li className="b-r">
                                                <Link to="#">
                                                    <img src={require('../../../images/images/footer_logo.png')} className="m-b-15" alt="" />
                                                </Link>
                                                <Link to="/apps">
                                                    <img src={require('../../../images/images/appstore_footer.png')} className="m-b-10" alt="" />
                                                </Link>
                                                <Link to="/apps">
                                                    <img src={require('../../../images/images/playstore_Footer.png')} alt="" />
                                                </Link>
                                            </li>
                                            <li className="b-r">
                                                <div className="listCompanyItem">
                                                    <h4>Our Company</h4>
                                                    <ul className="CompnayList">
                                                        <li>
                                                            <Link to="/marketing/about-us">
                                                                About us</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/contact-us">
                                                                Contact Us</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/terms">
                                                                Terms &amp; Conditions</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/privacy">
                                                                Privacy Policy</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/quality">
                                                                Quality &amp; Transparency</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/support-centre">
                                                                Support Centre</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li className="b-r">
                                                <div className="ft-link-block listCompanyItem">
                                                    <h4>For Patients</h4>
                                                    <ul className="CompnayList">
                                                        <li>
                                                            {/* <Link to="#" onClick={this.openSignInModal.bind(this, '1')} to="">Sign In</Link> */}
                                                        </li>
                                                        <li>
                                                            {/* <Link to="#" onClick={this.openSignUpModal.bind(this, '1')} to="">Sign Up</Link> */}
                                                        </li>
                                                        <li>
                                                            <Link to="#">
                                                                Find a Specialist </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/#Benifits">
                                                                Benefits of the ER App</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li className="b-r">
                                                <div className="ft-link-block listCompanyItem">
                                                    <h4>For Specialists</h4>
                                                    <ul className="CompnayList">
                                                        <li>
                                                            {/* <Link to="#" onClick={this.openSignInModal.bind(this, '2')} to="">Sign In</Link> */}
                                                        </li>
                                                        <li>
                                                            {/* <Link to="#" onClick={this.openSignUpModal.bind(this, '2')} to="">Sign Up</Link> */}
                                                        </li>
                                                        <li>
                                                            <Link to="#" href="for-specialist/#Joinus">
                                                                Why Join Us?</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="ft-link-block listCompanyItem">
                                                    <h4>Apps</h4>
                                                    <ul className="CompnayList">
                                                        <li>
                                                            <Link to="/marketing/apps">
                                                                Patient Android App</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/apps">
                                                                Patient iOS App</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/apps">
                                                                Specialists Android App </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/marketing/apps">
                                                                Specialists iOS App</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <ul className="list-inline social-icon">
                                            <li className="m-5">
                                                <Link to="#">
                                                    <i className="fa fa-facebook"></i>
                                                </Link>
                                            </li>
                                            <li className="m-5">
                                                <Link to="#">
                                                    <i className="fa fa-twitter"></i>
                                                </Link>
                                            </li>
                                            <li className="m-5">
                                                <Link to="#">
                                                    <i className="fa fa-google"></i>
                                                </Link>
                                            </li>
                                            <li className="m-5">
                                                <Link to="#">
                                                    <i className="fa fa-pinterest-p"></i>
                                                </Link>
                                            </li>
                                            <li className="m-5">
                                                <Link to="#">
                                                    <i className="fa fa-linkedin"></i>
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="copyright">
                                <div className="">
                                    <div className="">
                                        {/* 
               <p className="copyTxt">Copyright &copy; MyCompany. All rights reserved.</p>
               */}
                                        <p className="copyTxt">Medfix © 2018. All rights reserved.</p>
                                    </div>
                                </div>
                            </div>
                        </footer>

        )
}